/* InputTextEditor.js */

"use strict";

const CommonEditor = require("./CommonEditor");

/**
 * @type {uiCoreTools}
 */
const uiCore = require("@gluenetworks/steve_ui_core");
const InputTextControl = uiCore.Control.Textfield.InputText;

class InputTextEditor extends CommonEditor {
    constructor(options) {
        super(options);
    }

    _createInput() {
        return new InputTextControl({
            darkTheme: true,
        });
    }

    /*****************************/
    /*  PUBLIC API IS INHERITED  */
    /*****************************/
}

module.exports = InputTextEditor;
